"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mobile__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "19fe188c-aae6-44ea-ab50-0108772f454b",
    x1: 48.09,
    y1: 45.09,
    x2: 143.91,
    y2: 140.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "mobile-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "d49b5c55-68e1-4a8b-aa85-2b66d456361a",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 80,
    height: 160,
    rx: 8,
    ry: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,174H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#19fe188c-aae6-44ea-ab50-0108772f454b)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,33a1,1,0,0,1,1,1V152a1,1,0,0,1-1,1H62a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h68m0-1H62a2,2,0,0,0-2,2V152a2,2,0,0,0,2,2h68a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 24,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 164,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b1e8d3b6-820b-45a5-9d71-f0dfafcb9947",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_mobile__dark;
exports.default = _default;